import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","grid-list-lg":""}},[_c(VLayout,{attrs:{"wrap":""}},[_c(VFlex,{attrs:{"xs12":""}},[_c('app-manejo-cuentas-banco',{attrs:{"propName":"cuentasBanco","value":_vm.value}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }